import styled from 'styled-components';
import { DiamondLogo, LogoColors } from 'ui/logo';
import { spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { DateFormat, TimeFormat, localizeDateTime, localizeRelativeTimeSince } from 'utils/l10n';
import { Cell } from './Cell';

const StyledCell = styled(Cell)`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const StyledLogo = styled(DiamondLogo)`
  display: block;
`;

type DateCreatedCellProps = { isSystemField: boolean; timestamp: string };

export const DateCreatedCell = ({ isSystemField, timestamp }: DateCreatedCellProps) => {
  const date = new Date(timestamp);
  const timeFromNow = localizeRelativeTimeSince(date);
  const dateToDisplay = localizeDateTime(date, {
    dateStyle: DateFormat.Short,
    showTime: true,
    timeStyle: TimeFormat.Locale,
  });
  return (
    <StyledCell>
      {isSystemField && (
        <Tooltip isEnabled={isSystemField} tooltipContent="System field">
          <StyledLogo color={LogoColors.BLACK} height={24} />
        </Tooltip>
      )}
      <Tooltip tooltipContent={dateToDisplay} isUnderlined isEnabled={!!timestamp}>
        {timeFromNow}
      </Tooltip>
    </StyledCell>
  );
};
